import { FontButtonGreyLightSemiBold } from '../../../utils/typografyApp';
import { Button } from './styled';

const SmallButton = ({children, onClick})=>{
    return(
        <Button onClick={onClick}>{children}</Button>
    );
}

export default SmallButton;